import React, { useState } from 'react';
import C from 'classnames';
import Connect from 'components/organisms/connect/connect';
import { useAppDispatch, useAppSelector } from 'store';
import { useMultiPatientCall } from 'infrastructure/providers/multi-patient-call-context';
import BaseButton from 'components/atoms/baseButton';
import ChevronDoubleDownIcon from 'components/atoms/icons/chevronDoubleDownIcon';
import LinkChainIcon from 'components/atoms/icons/link-cain';
import { useTranslation } from 'react-i18next';
import {
  useCallEndedEventListener,
  useCallStartedEventListener,
} from 'infrastructure/customEvents/callEvents';

import DraggableModal from '../draggableModal';
import s from './styles.module.scss';

const ConnectModal = () => {
  const [_callId, setCallId] = useState<string>('');
  const { startCall, endCall } = useMultiPatientCall();
  const [windowExpanded, setWindowExpanded] = useState(true);
  const [isOnCall, setIsOnCall] = useState(false);
  const isOpen = useAppSelector((state) => state.connect.connectPopoutOpen);
  const connectDetails = useAppSelector(
    (state) => state.connect.connectDetails,
  );
  const {
    connect: { handleConnectPopoutOpen, connectDetails: handleConnectDetails },
    linkedCallsReadings: { setIsPopupOpen, resetState },
  } = useAppDispatch();
  const { t } = useTranslation();

  const disableLinkReadingBtn = !isOnCall || !connectDetails?.isRpmCall;

  const handleClose = () => {
    const details = {
      phone: '',
      guid: '',
      isRpmCall: true,
      readingId: '',
      deviceId: '',
      actionFrom: undefined,
    };
    handleConnectDetails(details);
    handleConnectPopoutOpen(false);
    setIsPopupOpen(false);
    resetState();
  };

  useCallStartedEventListener(async () => {
    setIsOnCall(true);
  });
  useCallEndedEventListener(async () => {
    setIsOnCall(false);
  });

  return (
    <>
      <DraggableModal
        isOpen={isOpen}
        toggle={handleClose}
        title="Accuhealth Connect"
        id="connect-modal"
        footer={false}
        modalClassName={s.modal}
        bodyClassName={s['modal-body']}
        dataCy="connect-modal"
        destroyOnClose={false}
      >
        <div className={s.body}>
          <div
            className={C(s['connect-wrapper'], {
              [s.collapse]: !windowExpanded,
            })}
          >
            <Connect
              isOpen={isOpen}
              phoneNumber={connectDetails.phone}
              patientGuid={connectDetails.guid}
              setCallId={setCallId}
              isRpmCall={!!connectDetails.isRpmCall}
              readingId={connectDetails.readingId}
              deviceId={connectDetails.deviceId}
              actionFrom={connectDetails.actionFrom}
              windowExpanded
              onCallStarted={startCall}
              onCallEnded={endCall}
            />
          </div>
          <div className={s['actions-wrapper']}>
            <div className={s['actions-modals-btn-wrapper']}>
              <BaseButton
                label={t('linkedCallReadings.linkReadingsToCall')}
                icon={<LinkChainIcon />}
                type="secondary"
                disabled={disableLinkReadingBtn}
                onClick={async () => {
                  setIsPopupOpen(true);
                }}
              />
            </div>
            <BaseButton
              icon={
                <div
                  className={C(s['chevron-icon'], {
                    [s.down]: !windowExpanded,
                  })}
                >
                  <ChevronDoubleDownIcon />
                </div>
              }
              type="secondary"
              onClick={() => setWindowExpanded(!windowExpanded)}
            />
          </div>
        </div>
      </DraggableModal>
    </>
  );
};

export default ConnectModal;
